import * as Yup from 'yup'
import { TFunction } from '_metronic/i18n/Metronici18n'

/**
 * Alteração da cor pelo médico: motivo é obrigatório e a cor precisa ser diferente da efetiva.
 *
 * Rebaixar — inclusive de vermelho para verde — é permitido de propósito (decisão do épico): a
 * responsabilidade é do médico e fica registrada com autor e motivo. Por isso aqui não existe
 * nenhuma regra que barre cor menos grave.
 */
export const decisaoTriagemSchema = (t: TFunction, corEfetiva?: string) =>
  Yup.object({
    cor: Yup.string()
      .required(t('triagem.decisao.cor_obrigatoria'))
      .test('cor-diferente', t('triagem.decisao.cor_diferente'), (valor) => valor !== corEfetiva),
    motivo: Yup.string().trim().required(t('triagem.decisao.motivo_obrigatorio')),
  })
